<template>
  <div>
    <Card>
      <h2 style="text-align: center;margin:20px 0 0 0;">打卡设置</h2>
      <Divider/>
      <div style="width: 60%;margin: 0 auto">
        <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="150">
          <FormItem label="签到时间">
            <TimePicker transfer type="time" placeholder="签到开始时间" format="HH:mm"
                        v-model="formValidate.signBeginTime"
                        style="width: 200px"></TimePicker>
            <span> — </span>
            <TimePicker transfer type="time" placeholder="签到结束时间" format="HH:mm"
                        v-model="formValidate.signEndTime"
                        style="width: 200px"></TimePicker>
          </FormItem>
          <FormItem label="签退时间">
            <TimePicker transfer type="time" placeholder="签退开始时间" format="HH:mm"
                        v-model="formValidate.outBeginTime"
                        style="width: 200px"></TimePicker>
            <span> — </span>
            <TimePicker transfer type="time" placeholder="签退结束时间" format="HH:mm" v-model="formValidate.outEndTime"
                        style="width: 200px"></TimePicker>
          </FormItem>
        </Form>
      </div>
      <div style="position: relative">
        <div style="position: absolute;top: 5px;left:5px;z-index: 999">
          <span style="font-weight: bolder">{{ deptName }}</span>
        </div>
        <div id="bmap" style="width: 100%;height: 550px;margin-top: 0px"></div>
        <Tag size="large" v-if="circleObj !== null" closable
             @on-close="handleClose">
          中心点经纬度：[{{ circleObj.longitude }},{{ circleObj.latitude }}]，
          半径：{{ circleObj.radius }}m，
          中心点地址：{{ circleObj.address }}
        </Tag>
      </div>
      <div style="text-align: center;margin-top: 10px">
        <Button type="primary" @click="updateRange">更新</Button>
        <Button type="default" @click="goBack" style="margin-left: 8px">返回</Button>
      </div>
    </Card>
  </div>
</template>

<script>
import { BMapLoader } from '@/utils/mapLoader'

export default {
  name: "editRange",
  data() {
    return {
      deptName: '',
      searchPlace: null,
      searchLng: '',
      searchLat: '',
      circleRadius: 500,
      inspectorList: [],
      formValidate: {
        id: null,
        deptIndexCode: null,
        signBeginTime: null,
        signEndTime: null,
        outBeginTime: null,
        outEndTime: null,
        centerPointLongitude: null,
        centerPointLatitude: null,
        radius: 0,
        address: ''
      },
      ruleValidate: {
        // departmentId: [
        //   {required: true, message: '必填', trigger: 'blur'}
        // ],
      },
      circleObj: null
    }
  },
  mounted() {
    if (this.$route.query.id) {
      this.formValidate.id = this.$route.query.id
      this.deptName = this.$route.query.deptName
      this.getRangInfo()
    }
  },
  methods: {
    getRangInfo() {
      this.$http.get(`/api/dutySignConfigs/${this.formValidate.id}`).then(res => {
        console.log(res)
        if (res.status === 200) {
          this.formValidate.centerPointLatitude = res.data.centerPointLatitude
          this.formValidate.centerPointLongitude = res.data.centerPointLongitude
          this.formValidate.radius = res.data.radius
          this.formValidate.address = res.data.centerPointAddress
          this.formValidate.signBeginTime = res.data.signBeginTime
          this.formValidate.signEndTime = res.data.signEndTime
          this.formValidate.outBeginTime = res.data.outBeginTime
          this.formValidate.outEndTime = res.data.outEndTime
          this.initMap()
        }
      })
    },
    goBack() {
      this.$store.commit('app/closePage', {
        vm: this,
        fromName: this.$route.name,
        toName: 'signSet'
      })
    },
    handleClose(event, name) {
      // console.log(name)
      this.map.removeOverlay(this.circle);
      this.map.removeOverlay(this.marker);
      this.circleObj = null
    },
    initMap() {
      const _this = this
      BMapLoader(this.$mapSignRangeKey).then(BMap => {
        const map = new BMap.Map('bmap', { enableMapClick: false })
        _this.map = map
        _this.BMap = BMap
        map.disableKeyboard() // 禁用键盘操作地图
        map.enableScrollWheelZoom(true) // 开启鼠标滚轮缩放
        // 添加中心点和缩放等级，如果不添加，初始化出来页面为白屏
        map.centerAndZoom('德州市', 14)
        _this.geoCoder = new BMap.Geocoder()
        //标圆
        _this.drawCircle({
          centerPointLongitude: _this.formValidate.centerPointLongitude,
          centerPointLatitude: _this.formValidate.centerPointLatitude,
          radius: _this.formValidate.radius
        })

        _this.map.addEventListener('click', (e) => {
          // console.log(e)
          var lng = e.latlng.lng
          var lat = e.latlng.lat
          _this.drawCircle({
            centerPointLongitude: lng,
            centerPointLatitude: lat,
            radius: _this.formValidate.radius
          })
        })
      })
    },
    // 画圈
    drawCircle(item) {
      if (!this.BMap) {
        // this.initMap()
        return
      }
      //判断地图是否有圆形
      if (this.circle) {
        // 清除地图所有圆形跟标记点
        this.map.removeOverlay(this.circle)
        this.map.removeOverlay(this.marker)
      }
      let radius = item.radius
      // 圆obj
      let circleObj = {}
      // circleObj.id = item.id
      // circleObj.isDelete = 0
      // circleObj.departmentId = this.deptId
      circleObj.radius = radius
      circleObj.longitude = item.centerPointLongitude
      circleObj.latitude = item.centerPointLatitude

      // 画圆
      var circle = new this.BMap.Circle(new this.BMap.Point(item.centerPointLongitude, item.centerPointLatitude), radius, {
        strokeColor: '#FF33FF',
        strokeWeight: 2,
        strokeOpacity: 0.5,
        fillOpacity: 0.4,
        strokeStyle: 'dashed',
        strokeDasharray: [10, 10],
        // 线样式还支持 'dashed'
        fillColor: '#1791fc',
        zIndex: 100
      })
      circleObj.circle = circle
      this.circle = circle

      this.marker = new this.BMap.Marker(new this.BMap.Point(item.centerPointLongitude, item.centerPointLatitude), {
        // offset: 0
      })
      this.map.addOverlay(this.marker)
      this.map.addOverlay(this.circle)
      this.circle.enableEditing()
      this.mapViewAuto(new this.BMap.Point(item.centerPointLongitude, item.centerPointLatitude))

      const _this = this
      this.geoCoder.getLocation(new this.BMap.Point(item.centerPointLongitude, item.centerPointLatitude), function (rs) {
        // console.log(rs)
        circleObj.address = rs.address + rs.content.poi_desc
        _this.circleObj = { ...circleObj }
      })
      this.circle.addEventListener('lineupdate', (e) => {
        this.circleRadius = e.target.radius
        const lng = e.target.latLng.lng
        const lat = e.target.latLng.lat
        circleObj.latitude = lat
        circleObj.longitude = lng
        circleObj.radius = e.target.radius
        this.map.removeOverlay(this.marker)
        this.marker = new this.BMap.Marker(new this.BMap.Point(lng, lat), {
          // offset: 0
        })
        this.map.addOverlay(this.marker)
        // this.mapViewAuto(new this.BMap.Point(lng, lat))
        this.geoCoder.getLocation(new this.BMap.Point(lng, lat), function (rs) {
          // console.log(rs)
          circleObj.address = rs.address + rs.content.poi_desc
          _this.circleObj = { ...circleObj }
        })
      })
      console.log(this.circleObj)
    },
    mapViewAuto(point) {
      const centerPoint = this.map.getViewport([point])
      // 初始化地图，设置中心点坐标和地图级别
      this.map.centerAndZoom(centerPoint.center, 16)
    },
    //更新
    updateRange() {
      let params = {
        id: this.formValidate.id,
        // deptIndexCode: this.formValidate.deptIndexCode,
        signBeginTime: this.formValidate.signBeginTime,
        signEndTime: this.formValidate.signEndTime,
        outBeginTime: this.formValidate.outBeginTime,
        outEndTime: this.formValidate.outEndTime,
        centerPointLongitude: this.circleObj.longitude,
        centerPointLatitude: this.circleObj.latitude,
        radius: this.circleObj.radius,
        centerPointAddress: this.circleObj.address
      }
      console.log(params)
      this.$http.put(`/api/dutySignConfigs`, params).then(res => {
        console.log(res)
        if (res.status === 200) {
          this.$Message.success('更新成功！')
          this.goBack()
        } else {
          this.$Message.error('更新失败！')
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.my-autocomplete {

  li {
    line-height: 20px;
    padding: 5px;

    .name {
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .addr {
      font-size: 12px;
      color: #b4b4b4;
    }

    .highlighted .addr {
      color: #ddd;
    }

  }
}
</style>
